import { Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, sitePeripheralDeviceSubTypesLoadedState, sitePeripheralLoadedState } from "src/app/store/reducers";
import { getPeripheralDeviceSubtypesList, getSitePeripheralList } from "src/app/store/actions/sites/sites.actions";

import { PeripheralType, PeripheralTypeDTO, SitePeripheralDTO } from "src/app/models/Sites/sitePeripheralDTO";
import { PeripheralFormDialogComponent } from "./dialog/peripheral-form-dialog.component";

@Component({
  selector: "site-peripheral-details",
  templateUrl: "./peripheral-details.component.html",
  styleUrls: ["./peripheral-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PeripheralDetailsComponent implements OnDestroy {
  _siteCode: string;

  @Input() set siteCode(code: string) {
    this._siteCode = code;
    if (this._siteCode) {
      this.loadPeripherals(this._siteCode);
      this.loadPeripheralTypes();
    }
  }

  peripheralList$: Observable<SitePeripheralDTO[]>;
  peripheralList: SitePeripheralDTO[];
  peripheralSub: Subscription;

  peripheralTypesList$: Observable<PeripheralTypeDTO[]>;
  peripheralTypesList: PeripheralTypeDTO[];
  peripheralTypesSub: Subscription;

  currentPeripheral: SitePeripheralDTO;
  isPeripheralSelected = false;

  peripheralType = PeripheralType;

  constructor(
    private store: Store<AppState>,
    public dialog: MatDialog
  ) {
    this.peripheralList$ = this.store.pipe(select(sitePeripheralLoadedState));
    this.peripheralTypesList$ = this.store.pipe(select(sitePeripheralDeviceSubTypesLoadedState));
  }

  loadPeripherals(siteCode: string) {
    this.peripheralSub = this.peripheralList$.subscribe(
      (peripherals: SitePeripheralDTO[]) => {
        this.peripheralList = peripherals;
        if (peripherals && peripherals.length && this.currentPeripheral) {
          const { code: currentPeripheralCode } = this.currentPeripheral;
          this.currentPeripheral = peripherals.find(({ code }) => code === currentPeripheralCode);
        }
        this.resetPeripheral();
      }
    );
    this.store.dispatch(getSitePeripheralList({ 
      code: siteCode,
      pageReq: { realSize: true, offset: 0, limit: 999 },
    }));
  }

  loadPeripheralTypes() {
    this.peripheralSub = this.peripheralTypesList$.subscribe(
      (typeList) => {
        this.peripheralTypesList = typeList;
      }
    );
    this.store.dispatch(getPeripheralDeviceSubtypesList(null));
  }

  resetPeripheral() {
    this.dialog.closeAll();
    this.isPeripheralSelected = false;
    this.currentPeripheral = null;
  }

  selectPeripheral(peripheral: SitePeripheralDTO) {
    this.isPeripheralSelected = true;
    this.currentPeripheral = peripheral;

    this.openPeripheralFormDialog(false);
  }

  create() {
    this.isPeripheralSelected = false;
    this.currentPeripheral = null;

    this.openPeripheralFormDialog(true);
  }

  openPeripheralFormDialog(isCreate: boolean) {
    this.dialog.open(PeripheralFormDialogComponent, {
      autoFocus: false,
      data: {
        isCreate: isCreate,
        siteCode: this._siteCode,
        currentPeripheral: this.currentPeripheral,
        peripheralTypesList: this.peripheralTypesList,
      }
    });
  }

  ngOnDestroy(): void {
    if (this.peripheralSub) {
      this.peripheralSub.unsubscribe();
    }
    if (this.peripheralTypesSub) {
      this.peripheralTypesSub.unsubscribe();
    }
  }
}
